<template>
  <div class="costing-top">
    <div class="costing-variables container">
      <div class="row align-items-center">
        <div class="col-auto">
          <a @click="editRates = !editRates" class="btn btn-sm">
            <i v-if="editRates" class="fa fa-lock-open" />
            <i v-else class="fa fa-lock" />
          </a>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row align-items-center mb-0">
                <label class="control-label col-5">Hrs / Day</label>
                <div class="col-7">
                  <input v-model.number="projectCalculation.working_days" type="number" step="0.1" class="form-control form-control-sm" :disabled="!editRates" />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row align-items-center mb-0">
                <label class="control-label col-5">Hourly Rate</label>
                <div class="col-7">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">$</span>
                    <input
                      :value="hourlyRateDisplay"
                      @change="$emit('hourly-rate-changed', $event)"
                      type="number"
                      step="0.01"
                      class="form-control"
                      :disabled="!editRates"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row align-items-center mb-0">
                <label class="control-label col-5">Warranty</label>
                <div class="col-7">
                  <div class="input-group input-group-sm">
                    <input v-model.number="projectCalculation.warranty_percentage" type="number" step="0.01" min="0" max="1" class="form-control" :disabled="!editRates" />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="form-group row align-items-center mb-0">
                <label class="control-label col-5">Efficiency</label>
                <div class="col-7">
                  <div class="input-group input-group-sm">
                    <input v-model.number="projectCalculation.efficiency" type="number" step="0.01" min="0.01" max="1" class="form-control" :disabled="!editRates" />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    projectCalculation: { type: Object, required: true },
  },

  data() {
    return {
      editRates: false,
    }
  },

  computed: {
    hourlyRateDisplay() {
      return (this.projectCalculation.hourly_rate_cents / 100).toFixed(2)
    },
  },
}
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.costing-top {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 0;
}
.costing-variables .form-group {
  margin-bottom: 0;
}
.costing-variables .control-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #6c757d;
  white-space: nowrap;
}
</style>
